import { h as __h } from "preact";
import { signal } from "@preact/signals";
import { SearchParams } from "~/lib/search.js";
import html from "~/util/html.js";
import Button from "~/component/Button.js";
import Icon from "~/component/Icon.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Pagination.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Pagination.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} PaginationProps
 * @property {number} page
 * @property {(page: number) => void} onPageChange
 * @property {number} total
 * @property {number} size
 * @param {PaginationProps} props
 */
export default function Pagination(props) {
  const {
    page,
    onPageChange,
    total,
    size
  } = props;
  const totalPages = Math.max(1, Math.ceil(total / size));
  const first = total === 0 ? 0 : page * size + 1,
    last = page * size + size;
  return __h("div", {
    "class": css.pagination
  }, __h("span", {
    "class": css.info
  }, " ", first, "\u2013", Math.min(last, total), " of ", total, " "), __h(Button, {
    level: "tertiary",
    size: "small",
    disabled: page === 0,
    onClick: () => onPageChange(page - 1)
  }, __h(Icon, {
    name: "back",
    label: "previous page",
    size: 12
  })), __h(Button, {
    level: "tertiary",
    size: "small",
    disabled: page >= totalPages - 1,
    onClick: () => onPageChange(page + 1)
  }, __h(Icon, {
    name: "forward",
    label: "next page",
    size: 12
  })));
}
Pagination.State = class {
  size = 50;

  /**
   * @param {object} [options]
   * @param {number} [options.size]
   * @param {boolean} [options.local]
   */
  constructor({
    size = this.size,
    local = false
  } = {}) {
    this.size = size;
    this.page = local ? signal(0) : SearchParams.page;
  }
  query() {
    return {
      limit: this.size,
      offset: this.size * this.page.value
    };
  }

  /**
   * @param {{ data?: { count: number } }} query
   * @returns {PaginationProps}
   */
  props(query) {
    return {
      page: this.page.value,
      onPageChange: p => this.page.value = p,
      total: query.data?.count ?? 0,
      size: this.size
    };
  }
};